import { Component, OnInit } from '@angular/core';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';
import {QuestionsService} from '../../services/questions.service';
import {Page} from '../../../shared/models/page.interface';
import {Master} from '../../../admin/models/master.interface';

@Component({
  selector: 'app-question-categories',
  templateUrl: './question-categories.component.html',
  styleUrls: ['./question-categories.component.scss']
})
export class QuestionCategoriesComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  questionCategories!: Page<Master>;
  private search = '';
  private page: PageRequest = {page: 0, size: 100, sort: '', direction: 'asc'};
  constructor(private readonly questionsService: QuestionsService,
              private messageService: MessageService,
              private readonly router: Router) { }

  ngOnInit(): void {
    this.questionsService.getAllQuestionCategories(this.search, this.page).subscribe(
      data => this.questionCategories = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadQuestionCategories(event: PageRequest): void {
    this.page = event;
    this.questionsService.getAllQuestionCategories(this.search, event).subscribe(
      data => this.questionCategories = data
    );
  }

  searchQuestionCategories(search: string): void {
    this.search = search;
    this.questionsService.getAllQuestionCategories(this.search, this.page).subscribe(
      data => this.questionCategories = data
    );
  }

}
